import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

function UpgradeIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 19.2V4.8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.6 11.2L12 4.8L18.4 11.2"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}

export default UpgradeIcon;
